import { AssetListItem } from '@fleet-bffs/api-contract';
import { OperationalStatusEnum } from 'fleet-data-model';
import type { AssetMapMarkerWithPosition } from '../models/super-cluster-markers';

export enum StatusColor {
  RED = '#DC2832',
  GREEN = '#31B900',
  YELLOW = '#FCB415',
  BLUE = '#07AFDC',
  LIGHTBLUE = '#A4D8E1',
  GREY = '#D2D2D2',
  DARKGREY = '#595959',
}

export enum AssetStatusColorEnum {
  Success = 'SUCCESS',
  Warning = 'WARNING',
  Error = 'ERROR',
  Secondary = 'SECONDARY',
}

/**
 * Map operational status to a semantic asset color enum.
 * Use this enum across application logic; convert to a hex color
 * only when rendering (see `mapAssetStatusColorToHex`).
 */
export const getOperationalStateColorForIcon = (
  status: OperationalStatusEnum
): AssetStatusColorEnum => {
  switch (status) {
    case OperationalStatusEnum.OK:
    case OperationalStatusEnum.OK_WITH_INFO:
      return AssetStatusColorEnum.Success;
    case OperationalStatusEnum.CRITICAL:
      return AssetStatusColorEnum.Error;
    case OperationalStatusEnum.WARNING:
      return AssetStatusColorEnum.Warning;
    default:
      return AssetStatusColorEnum.Secondary;
  }
};

/**
 * Convert the semantic `AssetStatusColorEnum` to a hex color
 * for use in SVG rendering.
 */
export const mapAssetStatusColorToHex = (color: AssetStatusColorEnum): string => {
  switch (color) {
    case AssetStatusColorEnum.Success:
      return StatusColor.GREEN;
    case AssetStatusColorEnum.Warning:
      return StatusColor.YELLOW;
    case AssetStatusColorEnum.Error:
      return StatusColor.RED;
    case AssetStatusColorEnum.Secondary:
    default:
      return StatusColor.GREY;
  }
};

export const assetToMapMarker = (asset: AssetListItem): AssetMapMarkerWithPosition | null => {
  if (!asset) {
    return null;
  }

  const shortGenericName =
    'shortGenericName' in asset.assetDetails
      ? (asset.assetDetails as any).shortGenericName
      : undefined;

  const longitude = asset.machineData?.location?.longitude;
  const latitude = asset.machineData?.location?.latitude;

  return {
    iprId: asset.assetDetails.id,
    name: asset.assetDetails.name,
    position: [Number(longitude), Number(latitude)],
    assetType: asset.assetDetails.assetType as any,
    subcategoryIcon: asset.assetDetails.images?.subcategoryIcon,
    shortGenericName,
    operationalStatus: asset.status?.operationalStatus?.status,
    selected: false,
  };
};
